var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 17.1423V12.642M12.0005 12.642C12.4342 12.6424 12.8662 12.5879 13.2863 12.48M12.0005 12.642C11.5668 12.6424 11.1348 12.5879 10.7147 12.48M13.9292 18.8902C12.6548 19.1322 11.3462 19.1322 10.0718 18.8902M13.2863 20.9329C12.4314 21.0224 11.5695 21.0224 10.7147 20.9329M13.9292 17.1423V16.9778C13.9292 16.1351 14.4932 15.4151 15.2218 14.9925C16.4459 14.2836 17.4021 13.1908 17.9421 11.8834C18.4821 10.5761 18.5759 9.12708 18.2089 7.76099C17.8419 6.39491 17.0346 5.18799 15.9121 4.32725C14.7896 3.46651 13.4146 3 12.0001 3C10.5855 3 9.21049 3.46651 8.08799 4.32725C6.96549 5.18799 6.1582 6.39491 5.7912 7.76099C5.4242 9.12708 5.51798 10.5761 6.05801 11.8834C6.59804 13.1908 7.55418 14.2836 8.77826 14.9925C9.50688 15.4151 10.0718 16.1351 10.0718 16.9778V17.1423",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsight);
export default __webpack_public_path__ + "static/media/insight.4281efd965d0db608ff0639c890848b2.svg";
export { ForwardRef as ReactComponent };